/* ===========================================================================
   SEXIFRUITS · comportamiento de la tienda
   ---------------------------------------------------------------------------
   Este archivo NO se toca para cambiar precios ni textos: eso se hace desde
   el panel de Shopify (Productos y Personalizar).
   =========================================================================== */
(function () {
  "use strict";
  const $  = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const mq = (q) => window.matchMedia(q).matches;
  const REDUCE = mq("(prefers-reduced-motion: reduce)");
  const TOUCH  = mq("(pointer: coarse)");
  const SMALL  = mq("(max-width: 900px)");
  const conn = navigator.connection || {};
  const LOW = REDUCE || SMALL || conn.saveData === true ||
              (navigator.deviceMemory && navigator.deviceMemory < 4) ||
              (navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 4);
  const reduce = REDUCE;

  /* almacenamiento seguro: si el navegador lo bloquea, no rompe nada */
  const mem = {};
  const store = {
    get(k) { try { return localStorage.getItem(k); } catch (e) { return mem[k] ?? null; } },
    set(k, v) { try { localStorage.setItem(k, v); } catch (e) { mem[k] = v; } }
  };

  const toast = (m) => { const t = $("#toast"); if (!t) return; t.textContent = m; t.classList.add("show"); clearTimeout(toast._t); toast._t = setTimeout(() => t.classList.remove("show"), 3400); };

  /* red de seguridad: si una imagen no carga, se prueba su alternativa */
  document.addEventListener("error", (e) => {
    const img = e.target;
    if (!img || img.tagName !== "IMG" || img.dataset.fbDone) return;
    img.dataset.fbDone = "1";
    if (img.dataset.fb) img.src = img.dataset.fb; else img.style.visibility = "hidden";
  }, true);


  /* ================= 1. PRELOADER ================= */
  const pre = $("#pre");
  const hidePre = () => { if (pre && !pre.classList.contains("off")) { pre.classList.add("off"); document.body.classList.add("ready"); } };
  window.addEventListener("load", () => setTimeout(hidePre, 260));
  setTimeout(hidePre, 2600);

  /* ================= 2. CURSOR ================= */
  if (!TOUCH && mq("(pointer:fine)") && !SMALL && $("#cur") && $("#curR")) {
    const c = $("#cur"), r = $("#curR");
    let x = 0, y = 0, rx = 0, ry = 0, on = false;
    document.addEventListener("pointermove", (e) => {
      x = e.clientX; y = e.clientY;
      if (!on) { on = true; rx = x; ry = y; document.body.classList.add("has-cur"); }
      c.style.transform = `translate(${x}px,${y}px)`;
    }, { passive: true });
    (function loop() {
      rx += (x - rx) * .17; ry += (y - ry) * .17;
      r.style.transform = `translate(${rx}px,${ry}px)`;
      requestAnimationFrame(loop);
    })();
    document.addEventListener("pointerover", (e) => {
      const hot = e.target.closest("a,button,.gitem,input,.chip,.sres");
      document.body.classList.toggle("cur-hot", !!hot);
    });
    document.addEventListener("pointerleave", () => document.body.classList.remove("has-cur"));
  }

  /* ================= 3. RIPPLE ================= */
  document.addEventListener("pointerdown", (e) => {
    const b = e.target.closest(".btn"); if (!b || REDUCE) return;
    const r = b.getBoundingClientRect(), s = Math.max(r.width, r.height);
    const el = document.createElement("span");
    el.className = "ripple";
    el.style.cssText = `width:${s}px;height:${s}px;left:${e.clientX - r.left - s / 2}px;top:${e.clientY - r.top - s / 2}px`;
    b.appendChild(el); setTimeout(() => el.remove(), 700);
  });

  /* ================= 4. SONIDO SUTIL (desactivado por defecto) ================= */
  let AC = null;
  const sound = {
    on: store.get("sfx") === "1",
    play(kind) {
      if (!this.on) return;
      try {
        AC = AC || new (window.AudioContext || window.webkitAudioContext)();
        const t = AC.currentTime, o = AC.createOscillator(), g = AC.createGain();
        o.type = "sine";
        o.frequency.setValueAtTime(kind === "add" ? 660 : 420, t);
        o.frequency.exponentialRampToValueAtTime(kind === "add" ? 990 : 300, t + .12);
        g.gain.setValueAtTime(.0001, t);
        g.gain.exponentialRampToValueAtTime(.05, t + .015);
        g.gain.exponentialRampToValueAtTime(.0001, t + .22);
        o.connect(g).connect(AC.destination); o.start(t); o.stop(t + .24);
      } catch (e) {}
    },
    toggle() { this.on = !this.on; store.set("sfx", this.on ? "1" : "0"); paintSnd(); if (this.on) this.play("add"); }
  };
  function paintSnd() { const b = $("#sndTog"); if (b) { b.classList.toggle("on", sound.on); b.setAttribute("aria-pressed", String(sound.on)); } }

  /* ================= 5. PARTÍCULAS ================= */
  (function dust() {
    const cv = $("#dust"); if (!cv || LOW) { if (cv) cv.remove(); return; }
    const ctx = cv.getContext("2d"); let w, h, ps = [], raf, vis = true;
    const dpr = Math.min(devicePixelRatio || 1, 1.6);
    const size = () => { w = cv.width = innerWidth * dpr; h = cv.height = innerHeight * dpr; cv.style.width = innerWidth + "px"; cv.style.height = innerHeight + "px"; };
    size();
    for (let i = 0; i < 34; i++) ps.push({ x: Math.random() * w, y: Math.random() * h, r: (Math.random() * 1.9 + .5) * dpr, s: Math.random() * .18 + .04, o: Math.random() * .35 + .12, d: Math.random() * Math.PI * 2 });
    const tick = () => {
      ctx.clearRect(0, 0, w, h);
      for (const p of ps) {
        p.y -= p.s * dpr; p.x += Math.sin(p.d += .004) * .22 * dpr;
        if (p.y < -10) { p.y = h + 10; p.x = Math.random() * w; }
        ctx.beginPath(); ctx.arc(p.x, p.y, p.r, 0, 6.283);
        ctx.fillStyle = `rgba(150,140,105,${p.o})`; ctx.fill();
      }
      raf = requestAnimationFrame(tick);
    };
    tick();
    addEventListener("resize", () => { size(); }, { passive: true });
    document.addEventListener("visibilitychange", () => {
      if (document.hidden) { cancelAnimationFrame(raf); vis = false; }
      else if (!vis) { vis = true; tick(); }
    });
  })();

  /* ================= 6. AGUACATE + FRUTAS (parallax de ratón) ================= */
  const wrap = $("#avoWrap"), stage = $("#avoStage"), spec = null;
  const floaters = $$(".fruit");
  const fio = new IntersectionObserver((es) => es.forEach(e => { if (e.isIntersecting) { e.target.classList.add("in"); fio.unobserve(e.target); } }), { threshold: .05 });
  floaters.forEach(f => fio.observe(f));

  if (!TOUCH && !REDUCE) {
    let tx = 0, ty = 0, cx = 0, cy = 0;
    addEventListener("pointermove", (e) => {
      tx = (e.clientX / innerWidth - .5) * 2;
      ty = (e.clientY / innerHeight - .5) * 2;
      if (spec) { spec.style.setProperty("--mx", (28 + tx * 22) + "%"); spec.style.setProperty("--my", (26 + ty * 20) + "%"); }
    }, { passive: true });
    (function loop() {
      cx += (tx - cx) * .06; cy += (ty - cy) * .06;
      if (wrap) wrap.style.transform = `rotateY(${cx * 11}deg) rotateX(${-cy * 8}deg) translate3d(${cx * 12}px,${cy * 10}px,0)`;
      floaters.forEach(f => {
        const d = parseFloat(f.dataset.depth || 16);
        f.style.transform = `translate3d(${cx * d}px,${cy * d}px,0)`;
      });
      requestAnimationFrame(loop);
    })();
  }

  /* En Shopify las fotos las pone el propio tema desde el panel:
     no hace falta cargarlas desde JavaScript. */

  /* ================= 7. CARRITO (habla con Shopify) ================= */
  const CFG = window.SEXI || {};
  const RUTAS = CFG.rutas || {};
  const eur = (centimos) => {
    const n = (centimos || 0) / 100;
    return n.toLocaleString("es-ES", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " €";
  };

  const esc = (s) => String(s == null ? "" : s).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");  let carro = { items: [], item_count: 0, total_price: 0, items_subtotal_price: 0 };
  let promo = store.get("sf_promo") || "";

  const pedir = (url, opciones) =>
    fetch(url, Object.assign({ headers: { "Content-Type": "application/json", "Accept": "application/json" } }, opciones))
      .then(r => r.json());

  const leerCarro = () => pedir(RUTAS.carrito + ".js").then(c => { carro = c; return c; });

  function etaText() {
    const d = new Date();
    const late = d.getHours() >= (CFG.horaCorte || 14);
    const add = (n) => { const x = new Date(d); let c = 0; while (c < n) { x.setDate(x.getDate() + 1); if (x.getDay() !== 0 && x.getDay() !== 6) c++; } return x; };
    const a = add(late ? 2 : 1), b = add(late ? 3 : 2);
    const f = (x) => x.toLocaleDateString("es-ES", { weekday: "long", day: "numeric", month: "long" }).replace(",", "");
    return "Entrega estimada: entre el " + f(a) + " y el " + f(b);
  }

  function pintar() {
    const n = carro.item_count || 0;
    const sub = carro.items_subtotal_price || 0;
    const minimo = CFG.envioGratisDesde || 0;
    const gratis = minimo > 0 && sub >= minimo;

    const badge = $("#cartBadge");
    if (badge) { badge.textContent = n; badge.classList.toggle("on", n > 0); }
    const cuenta = $("#cartCount");
    if (cuenta) cuenta.textContent = n === 0 ? "Vacío" : n + (n === 1 ? " caja" : " cajas");

    const body = $("#cartBody"), foot = $("#cartFoot");
    if (!body) return;

    if (!n) {
      body.innerHTML = '<div class="cempty">' +
        '<svg class="ill" viewBox="0 0 100 100" aria-hidden="true"><use href="#i-avo" width="100" height="100"/></svg>' +
        '<p>Tu carrito está vacío.<br>Elige una caja y te la cortamos mañana.</p>' +
        '<a class="btn" href="' + (RUTAS.cajas || "/collections/all") + '"><span>Ver las cajas</span></a></div>';
      if (foot) foot.hidden = true;
    } else {
      body.innerHTML = carro.items.map((it, i) => {
        const foto = it.image
          ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, "_160x$1$2")) + '" alt="" loading="lazy">'
          : '<svg class="ill" viewBox="0 0 100 100" aria-hidden="true"><use href="#i-box-degustacion" width="100" height="100"/></svg>';
        return '<div class="citem" data-row="' + (i + 1) + '">' +
          '<span class="th">' + foto + '</span>' +
          '<div><h3>' + esc(it.product_title) + '</h3><p class="m">' + (it.variant_title && it.variant_title !== "Default Title" ? esc(it.variant_title) : "") + '</p>' +
          '<div class="row"><span class="qsel">' +
            '<button type="button" data-linea="' + (i + 1) + '" data-q="-1" aria-label="Quitar una unidad de ' + esc(it.product_title) + '">−</button>' +
            '<span>' + it.quantity + '</span>' +
            '<button type="button" data-linea="' + (i + 1) + '" data-q="1" aria-label="Añadir una unidad de ' + esc(it.product_title) + '">+</button>' +
          '</span><span class="pr">' + eur(it.final_line_price) + '</span></div>' +
          '<button class="cdel" type="button" data-del="' + (i + 1) + '">Eliminar</button></div></div>';
      }).join("");
      if (foot) foot.hidden = false;
    }

    const txt = $("#shipTxt"), fill = $("#shipFill"), bar = $("#shipBar");
    if (txt && minimo > 0) {
      const falta = Math.max(0, minimo - sub);
      txt.textContent = gratis ? "¡Genial! Tienes el envío gratuito." : "Solo faltan " + eur(falta) + " para conseguir envío gratuito.";
      if (fill) fill.style.width = Math.min(100, (sub / minimo) * 100) + "%";
      if (bar) bar.classList.toggle("done", gratis);
    } else if (bar) { bar.hidden = true; }

    const set = (sel, v) => { const el = $(sel); if (el) el.textContent = v; };
    set("#sumSub", eur(sub));
    set("#sumShip", gratis ? "Gratis" : "Se calcula al pagar");
    set("#sumTot", eur(carro.total_price || 0));
    const ahorroFila = $("#sumSaveRow");
    const ahorro = (carro.total_discount || 0);
    if (ahorroFila) ahorroFila.hidden = ahorro <= 0;
    set("#sumSave", "−" + eur(ahorro));
    set("#etaTxt", etaText());
    const pin = $("#promoIn"); if (pin) pin.value = promo;

    const mini = $("#miniBody");
    if (mini) {
      mini.innerHTML = n
        ? carro.items.slice(0, 3).map(it => {
            const foto = it.image
              ? '<img src="' + esc(it.image.replace(/(\.[a-z]+)(\?|$)/i, "_88x$1$2")) + '" alt="" style="width:44px;height:44px;object-fit:cover;border-radius:8px">'
              : '<svg class="ill" viewBox="0 0 100 100" aria-hidden="true" style="width:44px;height:44px"><use href="#i-box-degustacion" width="100" height="100"/></svg>';
            return '<div class="mrow">' + foto +
              '<span><b>' + esc(it.product_title) + '</b><span>' + it.quantity + ' × ' + eur(it.final_price) + '</span></span>' +
              '<span class="pr">' + eur(it.final_line_price) + '</span></div>'; }).join("") +
          (carro.items.length > 3 ? '<p class="small" style="padding-top:10px">y ' + (carro.items.length - 3) + ' más…</p>' : '') +
          '<div class="mfoot2"><button class="btn block sm" id="miniOpen"><span>Ver carrito · ' + eur(carro.total_price) + '</span></button></div>'
        : '<p class="small" style="padding:8px 0">Tu carrito está vacío.</p>';
    }
  }

  function volar(desde) {
    if (REDUCE || !desde) return;
    const destino = $("#cartBtn"); if (!destino) return;
    const tarjeta = desde.closest(".pcard");
    const img = tarjeta ? tarjeta.querySelector("img, svg") : null;
    if (!img) return;
    const a = img.getBoundingClientRect(), b = destino.getBoundingClientRect();
    let el;
    if (img.tagName === "IMG") { el = document.createElement("img"); el.src = img.currentSrc || img.src; }
    else { el = img.cloneNode(true); el.removeAttribute("class"); }
    el.className = "fly"; el.alt = "";
    el.style.left = a.left + a.width / 2 - 37 + "px";
    el.style.top = a.top + a.height / 2 - 37 + "px";
    document.body.appendChild(el);
    requestAnimationFrame(() => {
      el.style.transition = "transform .82s cubic-bezier(.5,-.15,.3,1), opacity .82s ease-in";
      el.style.transform = "translate(" + (b.left + b.width / 2 - (a.left + a.width / 2)) + "px," + (b.top + b.height / 2 - (a.top + a.height / 2)) + "px) scale(.12) rotate(28deg)";
      el.style.opacity = ".2";
    });
    setTimeout(() => el.remove(), 900);
  }

  /* añadir al carrito sin recargar la página */
  document.addEventListener("submit", (e) => {
    const form = e.target.closest('form[action*="/cart/add"]');
    if (!form) return;
    e.preventDefault();
    const boton = form.querySelector('[type="submit"]');
    const datos = new FormData(form);
    if (boton) boton.disabled = true;
    fetch(RUTAS.anadir + ".js", { method: "POST", body: datos, headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(res => {
        if (res.status && res.status !== 200) { toast(res.description || "No se ha podido añadir."); return; }
        return leerCarro().then(() => {
          pintar();
          const badge = $("#cartBadge");
          if (badge) { badge.classList.remove("pop"); void badge.offsetWidth; badge.classList.add("pop"); }
          volar(boton); sound.play("add");
          if (boton && boton.classList.contains("padd")) {
            boton.classList.add("done");
            const lab = boton.querySelector("span:not(.chk)");
            if (lab) { const old = lab.textContent; lab.textContent = "Añadido";
              setTimeout(() => { boton.classList.remove("done"); lab.textContent = old; }, 1500); }
          }
        });
      })
      .catch(() => toast("No hemos podido añadirlo. Inténtalo otra vez."))
      .finally(() => { if (boton) boton.disabled = false; });
  });

  function cambiarLinea(linea, cantidad) {
    return pedir(RUTAS.cambiar + ".js", { method: "POST", body: JSON.stringify({ line: linea, quantity: cantidad }) })
      .then(c => { carro = c; pintar(); });
  }

  document.addEventListener("click", (e) => {
    const q = e.target.closest("[data-q][data-linea]");
    if (q) {
      const linea = parseInt(q.dataset.linea, 10);
      const it = carro.items[linea - 1]; if (!it) return;
      const nueva = it.quantity + parseInt(q.dataset.q, 10);
      if (nueva <= 0) sound.play("rm");
      cambiarLinea(linea, Math.max(0, nueva));
      return;
    }
    const del = e.target.closest("[data-del]");
    if (del) {
      const linea = parseInt(del.dataset.del, 10);
      const nodo = $('[data-row="' + linea + '"]');
      if (nodo) nodo.classList.add("out");
      sound.play("rm");
      setTimeout(() => cambiarLinea(linea, 0), 300);
      return;
    }
    /* selector de cantidad de la tarjeta */
    const cq = e.target.closest("[data-cq]");
    if (cq) {
      const caja = cq.closest(".qsel").querySelector("span");
      const v = Math.max(1, Math.min(20, (parseInt(caja.textContent, 10) || 1) + parseInt(cq.dataset.cq, 10)));
      caja.textContent = v;
      const form = cq.closest("form");
      if (form) { const oculto = form.querySelector('input[name="quantity"]'); if (oculto) oculto.value = v; }
      return;
    }
  });

  /* abrir y cerrar */
  const cartEl = $("#cart"), scrim = $("#scrim");
  const abrirCarro = () => { if (!cartEl) return; cartEl.classList.add("on"); scrim.classList.add("on"); document.documentElement.style.overflow = "hidden"; const x = $("#cartX"); if (x) x.focus(); };
  const cerrarCarro = () => { if (!cartEl) return; cartEl.classList.remove("on"); scrim.classList.remove("on"); document.documentElement.style.overflow = ""; };
  const cb = $("#cartBtn"); if (cb) cb.addEventListener("click", abrirCarro);
  const cx = $("#cartX"); if (cx) cx.addEventListener("click", cerrarCarro);
  if (scrim) scrim.addEventListener("click", () => { cerrarCarro(); cerrarBuscador(); });
  document.addEventListener("click", (e) => { if (e.target.closest("#miniOpen")) abrirCarro(); });

  const cartHold = $("#cartHold"), mini = $("#mini");
  if (cartHold && mini && !TOUCH) {
    let t1;
    cartHold.addEventListener("pointerenter", () => { clearTimeout(t1); if (carro.item_count) mini.classList.add("on"); });
    cartHold.addEventListener("pointerleave", () => { t1 = setTimeout(() => mini.classList.remove("on"), 260); });
  }

  /* código de descuento: lo valida Shopify al pagar */
  const pbtn = $("#promoBtn");
  if (pbtn) pbtn.addEventListener("click", () => {
    const v = ($("#promoIn").value || "").trim().toUpperCase();
    const msg = $("#promoMsg");
    promo = v; store.set("sf_promo", v);
    if (!v) { msg.textContent = ""; msg.className = "promo-msg"; return; }
    msg.textContent = "Se aplicará al finalizar la compra.";
    msg.className = "promo-msg ok";
    sound.play("add");
  });
  const pin = $("#promoIn");
  if (pin) pin.addEventListener("keydown", (e) => { if (e.key === "Enter") { e.preventDefault(); pbtn.click(); } });

  /* finalizar compra */
  const bco = $("#checkout");
  if (bco) bco.addEventListener("click", () => {
    if (!carro.item_count) { toast("Tu carrito está vacío."); return; }
    window.location.href = promo
      ? "/discount/" + encodeURIComponent(promo) + "?redirect=/checkout"
      : "/checkout";
  });

  leerCarro().then(pintar).catch(() => {});

  /* ================= 8. BUSCADOR (usa el buscador de Shopify) ================= */
  const srch = $("#srch"), srchIn = $("#srchIn"), srchRes = $("#srchRes");
  let sel = -1, ultimoFoco = null, peticion = 0;

  const historial = () => { try { return JSON.parse(store.get("sf_hist") || "[]"); } catch (e) { return []; } };
  const guardarHist = (q) => { const h = historial().filter(x => x !== q); h.unshift(q); store.set("sf_hist", JSON.stringify(h.slice(0, 4))); };

  function fila(it) {
    const foto = it.imagen
      ? '<span class="th"><img src="' + esc(it.imagen) + '" alt="" loading="lazy"></span>'
      : '<span class="th ico"><svg class="ill" viewBox="0 0 100 100" aria-hidden="true"><use href="#i-box-degustacion" width="100" height="100"/></svg></span>';
    const derecha = it.precio != null
      ? '<span class="pr">' + eur(it.precio) + '</span><span class="av' + (it.disponible ? '' : ' no') + '">' + (it.disponible ? "Disponible" : "Fuera de temporada") + '</span>'
      : '<span class="av">Ver</span>';
    return '<button class="sres" type="button" role="option" data-href="' + esc(it.url) + '">' +
      foto + '<span><b>' + esc(it.titulo) + '</b><span class="d">' + esc(it.desc || "") + '</span></span>' +
      '<span class="rt">' + derecha + '</span></button>';
  }

  function pintarInicio() {
    const h = historial();
    srchRes.innerHTML =
      (h.length ? '<p class="sgroup">Búsquedas recientes</p><div class="chips">' +
        h.map(x => '<button class="chip" type="button" data-q="' + esc(x) + '">' + esc(x) + '</button>').join("") + '</div>' : '') +
      '<p class="sgroup">Escribe para buscar</p><p class="snone">Prueba con «mango», «aguacate» o «regalo».</p>';
  }

  function buscar() {
    const crudo = srchIn.value.trim(); sel = -1;
    if (!crudo) { pintarInicio(); return; }
    const mio = ++peticion;
    const url = (RUTAS.sugerencias || "/search/suggest") + ".json?q=" + encodeURIComponent(crudo) +
                "&resources[type]=product,page,article&resources[limit]=7&resources[options][unavailable_products]=last";
    fetch(url, { headers: { "Accept": "application/json" } })
      .then(r => r.json())
      .then(d => {
        if (mio !== peticion) return;            // llegó tarde: la descartamos
        const r = (d.resources && d.resources.results) || {};
        const productos = (r.products || []).map(p => ({
          grupo: "Caja", titulo: p.title, url: p.url,
          desc: (p.body || "").replace(/<[^>]*>/g, "").slice(0, 70),
          imagen: p.featured_image && p.featured_image.url ? p.featured_image.url.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") : "",
          precio: p.price != null ? Math.round(parseFloat(p.price) * 100) : null,
          disponible: p.available !== false
        }));
        const paginas = [].concat(r.pages || [], r.articles || []).map(p => ({
          grupo: "Página", titulo: p.title, url: p.url, desc: (p.body || "").replace(/<[^>]*>/g, "").slice(0, 70)
        }));
        const todo = productos.concat(paginas);
        if (!todo.length) {
          srchRes.innerHTML = '<p class="snone">No hemos encontrado «' + esc(crudo) + '».' +
            '<br>Prueba con «mango», «aguacate» o «regalo».</p>';
          return;
        }
        let html = "", ultimo = "";
        todo.forEach(it => { if (it.grupo !== ultimo) { html += '<p class="sgroup">' + it.grupo + '</p>'; ultimo = it.grupo; } html += fila(it); });
        srchRes.innerHTML = html;
      })
      .catch(() => { srchRes.innerHTML = '<p class="snone">El buscador no responde. Prueba otra vez.</p>'; });
  }

  let tBusca;
  function abrirBuscador() {
    if (!srch) return;
    ultimoFoco = document.activeElement;
    srch.classList.add("on"); document.documentElement.style.overflow = "hidden";
    pintarInicio(); setTimeout(() => srchIn.focus(), 60);
  }
  function cerrarBuscador() {
    if (!srch || !srch.classList.contains("on")) return;
    srch.classList.remove("on"); document.documentElement.style.overflow = "";
    srchIn.value = ""; if (ultimoFoco) ultimoFoco.focus();
  }
  const sbtn = $("#srchBtn"); if (sbtn) sbtn.addEventListener("click", abrirBuscador);
  const sesc = $("#srchEsc"); if (sesc) sesc.addEventListener("click", cerrarBuscador);
  if (srch) srch.addEventListener("click", (e) => { if (e.target === srch) cerrarBuscador(); });
  if (srchIn) srchIn.addEventListener("input", () => { clearTimeout(tBusca); tBusca = setTimeout(buscar, 220); });

  if (srchRes) srchRes.addEventListener("click", (e) => {
    const chip = e.target.closest("[data-q]");
    if (chip) { srchIn.value = chip.dataset.q; buscar(); srchIn.focus(); return; }
    const r = e.target.closest(".sres");
    if (!r) return;
    if (srchIn.value.trim()) guardarHist(srchIn.value.trim());
    window.location.href = r.dataset.href;
  });

  document.addEventListener("keydown", (e) => {
    const escribiendo = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement.tagName);
    if (e.key === "/" && !escribiendo) { e.preventDefault(); abrirBuscador(); return; }
    if ((e.key === "k" || e.key === "K") && (e.metaKey || e.ctrlKey)) { e.preventDefault(); abrirBuscador(); return; }
    if (e.key === "Escape") { cerrarBuscador(); cerrarCarro(); return; }
    if (!srch || !srch.classList.contains("on")) return;
    const filas = $$(".sres", srchRes);
    if (!filas.length) return;
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      e.preventDefault();
      sel = (sel + (e.key === "ArrowDown" ? 1 : -1) + filas.length) % filas.length;
      filas.forEach((r, i) => r.classList.toggle("sel", i === sel));
      filas[sel].scrollIntoView({ block: "nearest" });
    }
    if (e.key === "Enter") { e.preventDefault(); (filas[sel] || filas[0]).click(); }
  });


  /* ---------- aviso de cookies ---------- */
  (function () {
    const ckb = $("#ckb");
    if (!ckb) return;
    if (!store.get("sf_ck")) setTimeout(() => ckb.classList.add("on"), 1200);
    $$("[data-ck]").forEach(b => b.addEventListener("click", () => {
      store.set("sf_ck", b.dataset.ck);
      ckb.classList.remove("on");
      toast(b.dataset.ck === "all" ? "Cookies aceptadas." : "Solo cookies necesarias.");
    }));
  })();

  /* ---------- 4. Cabecera ---------- */
  const hdr = $("#hdr"), hero = $(".hero");
  let lastY = window.scrollY;
  const onScroll = () => {
    const y = window.scrollY;
    hdr.classList.toggle("solid", y > 40);
    if (hero) hdr.classList.toggle("over", y < hero.offsetHeight - 90 && !document.body.classList.contains("menu-open"));
    hdr.classList.remove("hide"); // el carrito debe estar siempre visible
    lastY = y;
    const wa = $("#wafloat"); if (wa) wa.classList.toggle("show", y > 700);
  };
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();

  /* ---------- 5. Menú móvil ---------- */
  const burger = $("#burger"), mmenu = $("#mmenu");
  const closeMenu = () => {
    document.body.classList.remove("menu-open");
    burger.setAttribute("aria-expanded", "false");
    mmenu.setAttribute("aria-hidden", "true");
    document.documentElement.style.overflow = "";
    onScroll();
  };
  burger.addEventListener("click", () => {
    const open = !document.body.classList.contains("menu-open");
    document.body.classList.toggle("menu-open", open);
    burger.setAttribute("aria-expanded", String(open));
    mmenu.setAttribute("aria-hidden", String(!open));
    document.documentElement.style.overflow = open ? "hidden" : "";
    if (open) hdr.classList.remove("over", "hide");
    else onScroll();
  });
  $$("#mmenu a").forEach(a => a.addEventListener("click", closeMenu));

  /* ---------- 6. Reveal al hacer scroll ---------- */
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
    });
  }, { rootMargin: "0px 0px -8% 0px", threshold: 0.08 });
  $$("[data-r], .vcard, .step").forEach(el => io.observe(el));

  /* ---------- 7. Contadores ---------- */
  const cio = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target, target = parseInt(el.dataset.count, 10) || 0;
      cio.unobserve(el);
      if (reduce || target === 0) { el.textContent = target; return; }
      const dur = 1500, t0 = performance.now();
      const tick = (t) => {
        const p = Math.min((t - t0) / dur, 1);
        el.textContent = Math.round(target * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    });
  }, { threshold: 0.5 });
  $$("[data-count]").forEach(el => cio.observe(el));

  /* ---------- 9. Galería: flechas + arrastrar ---------- */
  const rail = $("#rail");
  if (rail) {
    const step = () => Math.max(rail.clientWidth * 0.62, 280);
    const syncNav = () => {
      const max = rail.scrollWidth - rail.clientWidth - 4;
      $("#galPrev").disabled = rail.scrollLeft <= 4;
      $("#galNext").disabled = rail.scrollLeft >= max;
    };
    const gp = $("#galPrev"), gn = $("#galNext");
    if (gp) gp.addEventListener("click", () => rail.scrollBy({ left: -step(), behavior: "smooth" }));
    if (gn) gn.addEventListener("click", () => rail.scrollBy({ left:  step(), behavior: "smooth" }));
    rail.addEventListener("scroll", syncNav, { passive: true });
    window.addEventListener("resize", syncNav);
    syncNav();

    let down = false, startX = 0, startL = 0, moved = 0;
    rail.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "touch") return;
      down = true; moved = 0; startX = e.clientX; startL = rail.scrollLeft;
      rail.classList.add("drag");
    });
    window.addEventListener("pointermove", (e) => {
      if (!down) return;
      const d = e.clientX - startX; moved = Math.abs(d);
      rail.scrollLeft = startL - d;
    });
    window.addEventListener("pointerup", () => {
      if (!down) return;
      down = false; rail.classList.remove("drag"); syncNav();
      if (moved > 6) { rail.dataset.justDragged = "1"; setTimeout(() => delete rail.dataset.justDragged, 60); }
    });
  }

  /* ---------- 10. Visor de fotos ---------- */
  const items = $$(".gitem");
  const lb = $("#lb"), lbImg = $("#lbImg"), lbCap = $("#lbCap");
  if (lb && lbImg && lbCap) {
  let cur = 0, lastFocus = null;

  const lbFoto = $("#lbFoto");
  const show = (n) => {
    cur = (n + items.length) % items.length;
    const it = items[cur];
    const dibujo = () => {
      lbImg.querySelector("use").setAttribute("href", "#" + it.dataset.sym);
      lbImg.setAttribute("aria-label", it.dataset.cap || "");
      lbImg.style.display = "block"; if (lbFoto) lbFoto.style.display = "none";
    };
    // La foto sale del propio botón (data-full), sin esperar a que la
    // miniatura termine de cargar: si pulsabas rápido, antes salía el dibujo.
    let src = it.dataset.full || "";
    if (!src) {
      const f = it.querySelector("img.foto");
      if (f) src = f.currentSrc || f.src;
    }
    if (src && lbFoto) {
      lbFoto.onerror = dibujo;          // si la foto fallara, vuelve el dibujo
      lbFoto.removeAttribute("data-fb-done");
      lbFoto.style.visibility = "";
      lbFoto.src = src;
      lbFoto.alt = it.dataset.cap || "";
      lbFoto.style.display = "block"; lbImg.style.display = "none";
    } else {
      dibujo();
    }
    lbCap.textContent = it.dataset.cap || "";
  };
  const openLb = (n) => {
    lastFocus = document.activeElement;
    show(n); lb.classList.add("on");
    document.documentElement.style.overflow = "hidden";
    { const b = $("#lbX"); if (b) b.focus(); }
  };
  const closeLb = () => {
    lb.classList.remove("on");
    document.documentElement.style.overflow = "";
    if (lastFocus) lastFocus.focus();
  };
  items.forEach((it, n) => it.addEventListener("click", () => {
    if (rail && rail.dataset.justDragged) return;
    openLb(n);
  }));
  { const b = $("#lbX"); if (b) b.addEventListener("click", closeLb); }
  { const b = $("#lbP"); if (b) b.addEventListener("click", () => show(cur - 1)); }
  { const b = $("#lbN"); if (b) b.addEventListener("click", () => show(cur + 1)); }
  lb.addEventListener("click", (e) => { if (e.target === lb || e.target.tagName === "FIGURE") closeLb(); });
  document.addEventListener("keydown", (e) => {
    if (!lb.classList.contains("on")) {
      if (e.key === "Escape" && document.body.classList.contains("menu-open")) closeMenu();
      return;
    }
    if (e.key === "Escape") closeLb();
    if (e.key === "ArrowLeft") show(cur - 1);
    if (e.key === "ArrowRight") show(cur + 1);
  });

  } /* fin del visor */

  /* ---------- 11. Preguntas frecuentes ---------- */
  $$(".fitem").forEach(item => {
    const btn = $(".fq", item);
    btn.addEventListener("click", () => {
      const open = !item.classList.contains("on");
      $$(".fitem").forEach(o => { o.classList.remove("on"); $(".fq", o).setAttribute("aria-expanded", "false"); });
      if (open) { item.classList.add("on"); btn.setAttribute("aria-expanded", "true"); }
    });
  });

  /* ---------- 14. Scroll suave para navegadores sin soporte ---------- */
  $$('a[href^="#"]').forEach(a => a.addEventListener("click", (e) => {
    if (a.getAttribute("href") === "#") return;
    const id = a.getAttribute("href");
    if (id.length < 2) return;
    const t = document.querySelector(id);
    if (!t) return;
    e.preventDefault();
    t.scrollIntoView({ behavior: reduce ? "auto" : "smooth", block: "start" });
    history.replaceState(null, "", id);
  }));

})();
